import { render, staticRenderFns } from "./tableRegisterBusiness.vue?vue&type=template&id=38a5e186"
import script from "./tableRegisterBusiness.vue?vue&type=script&lang=js"
export * from "./tableRegisterBusiness.vue?vue&type=script&lang=js"
import style0 from "./tableRegisterBusiness.vue?vue&type=style&index=0&id=38a5e186&prod&lang=css"
import style1 from "./tableRegisterBusiness.vue?vue&type=style&index=1&id=38a5e186&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports